// Internal imports
import { Wrapper } from "./services-component.styles";
import ServicesList from "../service-list/service-list.component";
import Title from "../title/title-component";
import { FormattedMessage } from "react-intl";
const Services = () => {
  return (
    <Wrapper className="section">
      <Title
        align="left"
        title={<FormattedMessage id="services" defaultMessage="Services" />}
      />
      <ServicesList />
    </Wrapper>
  );
};
export default Services;
